const call_emergency = `Hei, minulla on tällä hetkellä voimakasta rintakipua ja tarvitsen välitöntä lääkärin apua.
Asun lähellä julkista koulua.
Minäkin kaaduin ja jalkani vuotaa verta.
Lähetä ambulanssi mahdollisimman pian. Kiitos`;

export default call_emergency;